export default __webpack_public_path__ + "static/media/CercanaLogo.e85d5f4b.png";